import type { Theme } from '../../themes/themes';

export const createFlyoutTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiDrawer: {
      styleOverrides: {
        root: {
          '& .MuiBackdrop-root': {
            backgroundColor: 'rgba(0,0,0,0.45)',
          },
          '.PortalsCloseButton-Button': {
            position: 'absolute',

            top: '12px',
            right: '12px',
            [theme.breakpoints.up('sm')]: {
              top: '24px',
              right: '24px',
            },
            [theme.breakpoints.up('md')]: {
              top: '36px',
              right: '36px',
            },
            [theme.breakpoints.up('lg')]: {
              top: '40px',
              right: '40px',
            },
          },
          variants: [
            {
              props: {
                anchor: 'bottom',
              },
              style: {
                '.MuiPaper-root': {
                  padding: `${theme.spacing(8)} ${theme.spacing(5)} 0`,
                  borderRadius: `${theme.spacing(4)} ${theme.spacing(4)} 0 0`,
                },
              },
            },
          ],
        },
      },
    },
  },
});
